<template>
  <path pid="0" d="M13.58 24.33a11 11 0 10-11-11 11 11 0 0011 11zm0-20a9 9 0 11-9 9 9 9 0 019-9z"/><path pid="1" d="M9.87 17l.1.09a1 1 0 001.32-.09l2.29-2.29L15.87 17a1 1 0 001.42 0l.08-.09a1 1 0 00-.08-1.32L15 13.33 17.29 11a1 1 0 000-1.41l-.1-.08a1 1 0 00-1.32.08l-2.29 2.29-2.29-2.26a1 1 0 00-1.42 0l-.08.09A1 1 0 009.87 11l2.3 2.3-2.3 2.29a1 1 0 000 1.41z"/>
</template>
